import { useKeycloak } from "@react-keycloak/web";
import { AppBar, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import AppsIcon from "@mui/icons-material/Apps";
//import mainLogo from "../../assets/icons/Logo.svg";
import orchastroLogo from "../../assets/icons/orchstro.png";
const TopBar = () => {
  const { keycloak } = useKeycloak();

  return (
    <AppBar sx={{ backgroundColor: "#050D2E" }}>
      <Grid
        container
        sx={{
          height: "48px",
          background: "#050D2E",
          color: "white",
        }}
        px={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          // xs={2}
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item>
            <AppsIcon />
          </Grid>
          <Grid
            item
            sx={{
              " &.MuiGrid-item ": {
                p: 0,
                paddingTop: "10px",
              },
            }}
          >
            <Link
              to={keycloak.hasRealmRole("super-admin") ? "/admin" : "/"}
              style={{ textDecoration: "none", color: "white" }}
            >
              <img
                src={orchastroLogo}
                loading="lazy"
                alt="website-logo"
                width="165"
              />
            </Link>
            {keycloak.hasRealmRole("super-admin") ? "Admin" : null}
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default TopBar;
